import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import useStateWithCallback from 'use-state-with-callback';

const DropdownList = ({ children, link = "", title = ""}) => {
  const [dropup, setDropUp] = useState(false)
  const [open, setOpen] = useStateWithCallback(false, i => {
    if (i) {
      document.addEventListener('click', close);
    } else {
      document.removeEventListener('click', close);
    }
  });
  const listRef = useRef(null);

  const close = (event) => {
    if (open && listRef.current) {
      if(!listRef.current.contains(event.target)) {
        setOpen(false);
      }
    } else {
      document.removeEventListener('click', close);
    }
  }

  const mainClass = classNames(
    'shared-dropdown-list',
    {
      'shared-dropdown-list--open': open
    }
  );

  const linkClass = classNames(
    'shared-dropdown-list__link'
  );

  const dropDownClass = classNames(
    'shared-dropdown-list__list',
    {
      'shared-dropdown-list__list--dropup': dropup
    }
  );

  const handleClick = (event) => {
    setDropUp(endOfWindow(event));
    setOpen(!open);
  }

  const endOfWindow = (event) => {
    /* ! change default dropdown list size if add new elements
     * or change to automaticly size calculation */
    let defaultDropDownSize = 400
    let bottom = event.target.parentNode.getBoundingClientRect().bottom

    return (window.innerHeight - bottom <= defaultDropDownSize)
  }

  return <div className={mainClass} ref={listRef}>
            <div className={linkClass} onClick={handleClick}>
              <div>
                {link}
              </div>
            </div>
           {open && <div className={dropDownClass}>
               {title}
               <div className="shared-dropdown-list__list-items">
                 {children.map((child, i) => {
                   return <child.type {...child.props} key={i}/>
                   })
                 }
               </div>
             </div>
           }
        </div>
}

export default DropdownList;
